import {RouteObject} from "react-router-dom";

import RootLayout from "../layout/RootLayout";
import Home from "../pages/Home";
import {Course, Courses, CoursesIndex} from "../pages/Courses";
import Passwords from "../pages/Passwords";
import NoPage from "../pages/NoPage";
import React from "react";


import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";


import { getContacts } from "../data/contacts";

import { Outlet, Link, useRoutes, useParams } from "react-router-dom";
import Contacts from "../pages/Contacts";
import ErrorPage from "../pages/ErrorPage";
import Contact from "../pages/Contact";

import Succesfull from "../pages/Successfull";
import Failed from "../pages/Failed";

export async function rootLoader() {
    const contacts = await getContacts();
    return { contacts };
}



const routes  = createBrowserRouter([

    {
        path: process.env.PUBLIC_URL,
        element: <RootLayout />,
        errorElement: <ErrorPage />,
        loader: rootLoader,
        children: [
            { index: true, element: <Home /> },

            {
                path:  process.env.PUBLIC_UR+"/courses",
                element: <Courses />,
               // children: [
               //     { index: true, element: <CoursesIndex /> },
                //    { path:  process.env.PUBLIC_URL+"/courses/:id", element: <Course /> },
                //],
            },

            {
                path: process.env.PUBLIC_URL+"/passwords",
                element: <Passwords />,
            },

            {
                path: process.env.PUBLIC_URL+"/successfull",
                element: <Succesfull />,
            },

            {
                path: process.env.PUBLIC_URL+"/failed",
                element: <Passwords />,
            },

            {
                path: process.env.PUBLIC_URL+"/contacts",
                element: <Contacts />,
            },

            {
                path: process.env.PUBLIC_URL+"/contacts/:contactId",
                element: <Contact />,
            },

           // { path: "*", element: <NoPage/> },
        ],
    },
    ]
)


export default routes